// extracted by mini-css-extract-plugin
export default {"dotsContainer":"setupAccount_dotsContainer__Nmlx-","container":"setupAccount_container__V1k5X"};